<template>
  <div class="xxgk">
    <div class="breadcrumb"><a href="/">首页</a>&nbsp;&nbsp;>&nbsp;&nbsp;{{this.columnName}}</div>
    <ul>
      <li v-for="item in xxgkList" :key="item.column_id" @click="details(item.column_id)">{{item.column_name}}</li>
    </ul>
  </div>
</template>

<script>
import "@/assets/css/style.css";
import {imgPath,cityId,permissionsId,keywords,description,metatitle,SiteName,SiteDomain} from "@/api/api"
export default {
  name: "xxgk",
  data() {
    return {
			xxgkList: [],
      ldhdimgList: [],
      imgPath,
      cityId,
      permissionsId,
      columnName:''
    };
  },
  metaInfo(){
    return{
      title:this.columnName + "_" + metatitle,
      meta:[
        {name:'keywords',content:keywords},
        {name:"description",content:description},
        {name:"SiteName",content:SiteName},
        {name:"SiteDomain",content:SiteDomain},
        {name:"SiteIDCode",content:"辽ICP备16006427号-2"},
        {name:"ColumnName",content:this.columnName},
        {name:"ColumnDescription",content:this.columnName},
        {name:"ColumnKeywords",content:this.columnName},
        {name:"ColumnType",content:this.columnName}
      ]
    }
  },
  created() {
    this.httpPost();
  },
  methods: {
    httpPost() {
      const _this = this;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/GetNewsList",
        data:{
          "city_id":cityId,
          "permissions_id":permissionsId,
          "column_id":_this.$route.params.columnId
        },
        success(res){
          _this.xxgkList = res.extend.module_list;
          _this.columnName = res.extend.columnName;
        }
      })
    },
        details(id){
      if (id == "1") {
        let blank = this.$router.resolve({
          path: '/detail/details/' + id,
        });
        window.open(blank.href,'_blank')
      }
      else if (id == "2") {
        let blank = this.$router.resolve({
          path: '/detail/details/' + id,
        });
        window.open(blank.href,'_blank')
      }
      else if (id == "3") {
        let blank = this.$router.resolve({
          path: '/detail/details/' + id,
        });
        window.open(blank.href,'_blank')
      }
      else if (id == "15") {
        let blank = this.$router.resolve({
          path: '/detail/details/' + id,
        });
        window.open(blank.href,'_blank')
      }
      else{
        let blank = this.$router.resolve({
          path: '/list/' + id,
        });
        window.open(blank.href,'_blank')
      }
    }
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/xxgk/xxgk.vue